import { render, staticRenderFns } from "./ItemStatus.vue?vue&type=template&id=83738a6e&"
import script from "./ItemStatus.vue?vue&type=script&lang=js&"
export * from "./ItemStatus.vue?vue&type=script&lang=js&"
import style0 from "./ItemStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports